module.exports = __webpack_public_path__ + "img/Whats Next.49d82c94.jpg";